<template>
    <!--
            作者：kmdshop
            时间：2020-04-20
            描述：修改价格
        -->
    <el-dialog title="取货商品" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
               :close-on-press-escape="false" width="70%"   :append-to-body="true">
               <el-table  :data="store_order" style="width: 100%" border>
      
                        <!-- 商品名称 -->
                        <el-table-column prop="product_name" label="商品名称"></el-table-column>

                        <!-- 商品分类 -->
                        <el-table-column prop="category_name" label="商品分类" ></el-table-column>

                        <!-- 商品规格 -->
                        <el-table-column prop="spec_value" label="商品规格" ></el-table-column>

                        <!-- 单价 -->
                        <el-table-column prop="product_price" label="单价(元)" ></el-table-column>

                        <!-- 总金额 -->
                        <el-table-column prop="amount" label="总金额(元)" ></el-table-column>

                        <!-- 库存 -->
                        <el-table-column prop="act_stock" label="库存数量" ></el-table-column>

                        <!-- 设置数量 -->
                        <el-table-column prop="set_num" label="数量" ></el-table-column>

                        <!-- 商品单位 -->
                        <el-table-column prop="unit" label="单位"></el-table-column>

                        <!-- 仓库信息 -->
                        <el-table-column prop="warehousetext" label="仓库信息" ></el-table-column>

                        <!-- 库位信息 -->
                        <el-table-column prop="warehousekwtext" label="库位信息" ></el-table-column>

                        <el-table-column prop="is_ck" label="是否出库" ></el-table-column>


                        </el-table>

        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible">取 消</el-button>

        </div>
    </el-dialog>
</template>

<script>
    import OrderApi from '@/api/order.js';
    export default {
        data() {
            return {
                order_id: 0,
                loading: false,
                /*左边长度*/
                formLabelWidth: '100px',
                /*是否显示*/
                dialogVisible: false,
                /*表单*/
                order: {
                    update_price: 0,
                    update_express_price: 0.00,
                }
            };
        },
        props: ['open_edit','store_order'],
        created() {
            this.dialogVisible = this.open_edit
         
        },
        methods: {
//        

            /*关闭弹窗*/
            dialogFormVisible() {
                this.$emit('close', {openDialog: false});
            }
        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/order/order/quhuo.vue